declare global {
  interface Window {
    en: boolean;
  }
}

const en = window.en;

export function getRemainingTime(end: number, today: number, countdownCase?: string) {
  // Calculate the difference in milliseconds between the current date and the first day of the next year
  let remainingDate: null | number = null;
  // if (typeof end === 'number' && typeof todayDate === 'number') {
  remainingDate = end - today;
  // }

  // Calculate the number of whole days
  const oneDay = 24 * 60 * 60 * 1000; // milliseconds in one day
  let days = Math.floor(remainingDate / oneDay);

  // Calculate the number of whole weeks
  let weeks = Math.floor(remainingDate / (oneDay * 7));

  // Subtract the days accounted for by the weeks
  days = days - weeks * 7;

  // Return the remaining time in weeks and days
  if (countdownCase) {
    const weeksText = weeks > 0 ? `<div>${weeks} ${weeks > 1 ? (en ? 'weeks' : 'Wochen') : en ? 'week' : 'Woche'}</div>` : '';
    const daysText = days > 0 ? `<div>${days} ${days > 1 ? (en ? 'days' : 'Tage' + (countdownCase === 'dativ' ? 'n' : '')) : en ? 'day' : 'Tag'}</div>` : '';

    const countdownText = [weeksText, daysText].filter(t => t).join(en ? ' and ' : ' und ');
    return { countdownText, lastDay: days === 0 && weeks === 0 };
  } else {
    return { days, weeks };
  }
}
